<template>
  <div class="menu-icon" :class="{ 'is-active': value }" @click="$emit('input', !value)">
    <span />
    <span />
    <span />
  </div>
</template>

<script>
export default {
  name: 'MenuIcon',

  props: {
    value: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.menu-icon {
  width: 34px;
  height: 22px;
  transition: 0.4s $--ease-pattern;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  span {
    height: 4px;
    width: 100%;
    background: #fff;
    transition: 0.4s $--ease-pattern;
  }

  &.is-active span:nth-child(2) {
    opacity: 0;
    transform: translateX(60px);
  }

  /* menu-icon  span     */
  /* height/2 - height/2 */

  &.is-active span:nth-child(1) {
    transform: translateY(9px) rotate(135deg) scale(1.2);
  }

  &.is-active span:nth-child(3) {
    transform: translateY(-9px) rotate(-135deg) scale(1.2);
  }
}
</style>
